import { memo } from "react";

function WOR() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M14.8349 5.57803V7.15505H13.1389V5.57803H14.8349Z" fill="currentColor" />
      <path d="M7.15492 13.1388V14.8348H5.57791V13.1388H7.15492Z" fill="currentColor" />
      <path d="M22.3959 13.1388V14.8348H20.8189V13.1388H22.3959Z" fill="currentColor" />
      <path
        d="M14.1766 13.9183L17.7414 11.6908L18.6406 13.1294L14.4367 15.7572L13.7958 16.1565L9.12033 10.3121L10.4444 9.25253L14.1766 13.9183Z"
        fill="currentColor"
      />
      <path
        d="M23.1245 13.987C23.1245 8.94065 19.0332 4.84943 13.9869 4.84934C8.94045 4.84934 4.84918 8.94071 4.84918 13.987C4.84928 19.0332 8.9405 23.1247 13.9869 23.1247C14.4785 23.1247 14.9604 23.0854 15.4299 23.011C15.8924 22.9377 16.3271 23.2536 16.4004 23.7162C16.4736 24.1785 16.1584 24.6124 15.6961 24.6858C15.1388 24.7742 14.5676 24.8198 13.9869 24.8198C8.00388 24.8198 3.15326 19.9699 3.15317 13.987C3.15317 8.0041 8.00381 3.15332 13.9869 3.15332C19.9698 3.15342 24.8206 8.00403 24.8206 13.987C24.8205 14.768 24.7375 15.5312 24.5799 16.2666C24.4817 16.7245 24.0303 17.0162 23.5723 16.918C23.1147 16.8197 22.8228 16.3691 22.9209 15.9113C23.0537 15.2919 23.1245 14.6478 23.1245 13.987Z"
        fill="currentColor"
      />
      <path
        d="M26.2777 13.9868C26.2777 7.19886 20.7745 1.69603 13.9868 1.69602C7.19873 1.69602 1.69602 7.19884 1.69602 13.9868C1.69603 20.7746 7.19885 26.2777 13.9868 26.2777C14.6113 26.2777 15.2249 26.2308 15.8239 26.141C16.287 26.0718 16.7189 26.3911 16.7883 26.8542C16.8575 27.3172 16.5382 27.7491 16.0751 27.8185C15.3935 27.9207 14.6961 27.9737 13.9868 27.9737C6.26222 27.9737 1.19206e-05 21.7112 0 13.9868C0 6.26222 6.26209 0 13.9868 0C21.7111 1.19215e-05 27.9737 6.26221 27.9737 13.9868C27.9737 14.9448 27.8775 15.8813 27.6934 16.7865C27.6 17.2454 27.1518 17.5419 26.6928 17.4485C26.2342 17.355 25.9386 16.9076 26.0317 16.4489C26.1933 15.6546 26.2777 14.8311 26.2777 13.9868Z"
        fill="currentColor"
      />
      <path
        d="M21.0818 20.9345C21.0817 20.3379 20.598 19.8545 20.0017 19.8544C19.4054 19.8544 18.9216 20.3379 18.9216 20.9345C18.9216 21.5308 19.4054 22.0145 20.0017 22.0145C20.5981 22.0144 21.0818 21.5307 21.0818 20.9345ZM22.5421 20.9345C22.5421 22.3372 21.4045 23.4748 20.0017 23.4749C18.5989 23.4749 17.4613 22.3374 17.4613 20.9345C17.4613 19.5316 18.5987 18.394 20.0017 18.394C21.4045 18.3941 22.5421 19.5314 22.5421 20.9345Z"
        fill="currentColor"
      />
      <path
        d="M26.5122 25.46C26.5122 24.864 26.0286 24.3801 25.4321 24.3799C24.8359 24.3799 24.352 24.8639 24.352 25.46C24.3522 26.0563 24.8361 26.5393 25.4321 26.5393C26.0283 26.5392 26.512 26.0562 26.5122 25.46ZM27.9725 25.46C27.9723 26.8626 26.8348 27.9995 25.4321 27.9997C24.0295 27.9997 22.8919 26.8627 22.8917 25.46C22.8917 24.0574 24.0294 22.9196 25.4321 22.9196C26.8349 22.9197 27.9725 24.0573 27.9725 25.46Z"
        fill="currentColor"
      />
      <path
        d="M25.791 18.6392C26.0588 18.3379 26.5203 18.3108 26.8217 18.5785C27.1231 18.8464 27.1503 19.3079 26.8824 19.6092L19.6422 27.755C19.3743 28.0563 18.9128 28.0835 18.6115 27.8157C18.3101 27.5478 18.283 27.0863 18.5508 26.785L25.791 18.6392Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(WOR);
